//
// Move items to collapse
//

$.fn.moveIntoCollapse = function(entry, collapseEl, leaveOut) {
    var $this = $(this);
    
    // Create list of nots
    var eqNum = [];
    for (var i = 0; i < leaveOut; i++) {
        eqNum.push(':eq(' + i + ')');
    }
    
    // Move last nth entries into collapse
    $this
        .find(entry)
        .not(eqNum + " ")
        .appendTo(collapseEl);
    
    // Add class to parent
    $this
        .closest('.randomize-into-collapse')
        .addClass('show');
};